import router from "../router";
import store from "../store";
import cookie from "@utils/store/cookie";
import {isWeixin} from "@utils";
import {checkLeagueServ, checkTokenServ} from "@api/user";
import request from "@utils/request";

export default function toLoginLesson(push, backUrl) {
  console.log("未登录，走大学习登录")
  store.commit("LOGOUT");
  const {fullPath} = router.currentRoute;
  cookie.set("login_back_url", backUrl || fullPath);
  if (isWeixin()) {
    // 生产
    let domain = "qndxx.nmyouth.org.cn";
    let appId = "wx3cf4a63128c87f6e";
    // 测试
    // let domain = "6u3ijt.natappfree.cc";
    // let appId = "wx66255b5f01cc0de7";
    const redirect_uri = encodeURIComponent("http://" + domain + `/page/auth`);
    let bak_url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    console.log("跳转到微信页面：" + bak_url);
    location.href = bak_url;
  } else {
    alert("请使用微信浏览器登录");
  }
}

export function checkToken() {
  checkTokenServ().then(res => {
    let resultKey = res.resultKey;
    if (resultKey === "0") {
      return true;
    } else {
      return false;
    }
  });
}

export function checkLoginAndLeague(to) {
  // 先检查登录状态
  checkTokenServ().then(res => {
    console.debug(res);
    let resultKey = res.resultKey;
    if (
      typeof resultKey === "undefined" ||
      resultKey === undefined ||
      resultKey === "" ||
      resultKey == null
    ) {
      console.log("调用失败，走跳转重新调用");
      let resOld = res.toString();
      console.log(resOld);
      let code = resOld
        .split("http://qndxx.nmyouth.org.cn/service/user/checkTokenServ?")[1]
        .split('"')[0];
      console.log(code);
      let redirectPath = "/user/checkTokenServ?" + code;
      console.log(redirectPath);
      request.get(redirectPath).then(res2 => {
        console.log(":::::::::::res2=");
        console.log(res2);
        request.get("/user/checkTokenServ").then(res3 => {
          console.log(":::::::::::res3=");
          console.log(res3);
          let resultKey = res3.resultKey;
          if (resultKey === "1") {
            return toLoginLesson(true, to.fullPath);
          }
        });
      });
    } else if (resultKey === "1") {
      return toLoginLesson(true, to.fullPath);
    }
  });
  checkLeagueServ().then(res => {
    let resultKey = res.resultKey;
    if (resultKey === "2") {
      return toLoginLesson(true, to.fullPath);
    } else if (resultKey === "1") {
      router.push({
        path: "/user/league"
      });
    }
  });
}
